import { render, staticRenderFns } from "./StartFormYear.vue?vue&type=template&id=fe37ef88&scoped=true"
import script from "./StartFormYear.vue?vue&type=script&lang=js"
export * from "./StartFormYear.vue?vue&type=script&lang=js"
import style0 from "./StartFormYear.vue?vue&type=style&index=0&id=fe37ef88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe37ef88",
  null
  
)

export default component.exports